import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { TenantPermissionDto } from 'projects/shared/src/lib/models/PermissionForCreationDto';
import { PermissionsService } from 'projects/shared/src/lib/services/permissions.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';

@Component({
  selector: 'tenant-permissions-list',
  templateUrl: './tenant-permissions-list.component.html',
  styleUrls: ['./tenant-permissions-list.component.css']
})

export class TenantPermissionsListComponent implements OnInit {

  //@Input() actPlatformGroupRole!: PlatformGroupRoleDto;
  @Input() permissions: string = "";
  @Input() tenantRoles: string[] = [];
  tenantPermissions: TenantPermissionDto[] = [];

  @Output() onChangeEvent: EventEmitter<string> = new EventEmitter();

  _tenantName!: string;

  constructor(
    private permissionService: PermissionsService,
    private tenantService: TenantService
    )
    { }


  ngOnInit(): void {
    // this.platformGroupRolePermissions = this.data.platformGroupRolePermissions;
    // this.actPlatformGroupRole = this.data.platformGroupRole;
    console.log("--------> tenant-permissions-list")
    console.log("permissions = ",this.permissions)
    console.log("tenantRoles = ",this.tenantRoles)
    console.log("tenantName = ",this.tenantService.currentTenantName)

    // this._tenantName = localStorage.getItem('current-tenant-name') as string;
    this._tenantName = this.tenantService.currentTenantName;
    this.mapTenantPermissions()
  }

  mapTenantPermissions() {
    // all possible permissions
    this.permissionService.loadTenantPermissions(this._tenantName, new GenericFilter()).subscribe({
      next:(permissionDtos:any) => { 
        console.log("tenant permissions:", permissionDtos)
        this.tenantPermissions = permissionDtos;
        if (this._tenantName != "DEMOZUGANG")
          this.tenantPermissions.pop();
        if (this.permissions) {
          let permArrayRole = this.permissions.split(",");
          let permArrayPlatform = this.tenantPermissions;
          permArrayPlatform.forEach(function (platformPerm) {
            permArrayRole.forEach(function (rolePerm) {
              if (rolePerm == platformPerm.name) platformPerm.permissionValue = true;
            })
          }) 
        }
      }
    })
  }

  onChange() {
    this.onChangeEvent.emit(this.mapRolePermissions());
  }

  mapRolePermissions() : string{
    this.permissions = "";
    let permArrayPlatform = this.tenantPermissions;
    let newPerms = "";
    permArrayPlatform.forEach(function (platformPerm) {
      if (newPerms != "" && platformPerm.permissionValue) newPerms += ",";
      if (platformPerm.permissionValue) newPerms += platformPerm.name;
    }) 
    this.permissions = newPerms;
    return newPerms
  }
}